import {NaturezaDespesa} from "./natureza-despesa";
import {Item} from "./item";
import {Forca} from "./forca";
import {Conta} from "./conta";

export class Meta {
    id: number = -1;
    contaCapital: Conta = new Conta();
    contaCusteio: Conta = new Conta();
    descricao: string = "";
    fonteRecurso: string = "";
    forca: Forca = new Forca();
    itens: Item[] = new Array<Item>();
    naturezaDespesa: NaturezaDespesa = new NaturezaDespesa();
    numeroEdoc: string = "";
    percentualExecutado: number = -1;
    valorCapital: number = -1;
    valorCusteio: number = -1;
    valorEstimado: number = -1;
    valorRendimentoCapital: number = -1;
    valorRendimentoCusteio: number = -1;
    valorTotal: number = -1;

    //DTO
    idContaCapital: number = -1;
    idContaCusteio: number = -1;
    idFonteRecurso: number = -1;
}